module.exports = {"ADM_INSPECT_ACCOUNTS_SEEING_AS":"Viewing as","ADM_INSPECT_ACCOUNTS_BACK_TO_ADMIN":"Return to Admin"}